import PropTypes from "prop-types";
import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { Switch, Link } from "react-router-dom";
import ViewHelpers from "./components/viewHelpers";
import MainMenu from "./components/mainMenu";
import VideoBackground from "./components/videoBackground";
import SubNavigation from "./components/subNavigation";
import VisibiltySensor from "react-visibility-sensor";
import InstagramFeed from "./components/instagramFeed";
import ContactForm from "./components/homeContactForm";
import Footer from "./components/footer";

export default class Home extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showNavLogo: false,
			currentFrame: null,
			width: 0,
			height: 0
		};
	}

	componentDidMount() {
		document.title = "QwixSkinz || High Performance Race Suits";
		this.setState({ width: window.innerWidth, height: window.innerHeight });
		window.addEventListener("resize", this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize);
	}

	onResize = () => {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	};

	updateCurrentFrame = i => {
		this.setState({ currentFrame: i });
	};

	animate = (opt, style = {}) => {
		let _doAnimate = opt => {
			const { currentFrame } = this.state;
			const { frameIn, frameOut, fade, move, scale } = opt;

			if (currentFrame < frameIn || currentFrame > frameOut) return;

			opt.style = { display: "block" };
			opt.travel = frameOut - frameIn;
			opt.completion = (currentFrame - frameIn) / (frameOut - frameIn);

			if (move) {
				opt = this.move(opt);
			}

			if (fade) {
				opt = this.fade(opt);
			}

			if (scale) {
				opt = this.scale(opt);
			}
			return Object.assign({}, opt.style, style);
		};

		let result = Array.isArray(opt)
			? Object.assign({}, ...opt.map(_doAnimate).filter(s => !!s))
			: _doAnimate(opt);

		result = Object.keys(result).length > 0 ? result : { display: "none" };
		return result;
	};

	scale = opt => {
		const {
			scale: { from, to }
		} = opt;
		let diff = from - to;
		let s = from - diff * opt.completion;
		if (!opt.style.transform) opt.style.transform = "";
		opt.style.transform += `scale(${s})`;
		return opt;
	};

	move = opt => {
		const { move } = opt;
		let { sx, sy } = move.startPosition;
		let { ex, ey } = move.endPosition;

		if (!opt.style.transform) opt.style.transform = "";

		opt.style.position = "fixed";
		opt.style.top = ey * opt.completion + sy * (1 - opt.completion);
		opt.style.left = ex * opt.completion + sx * (1 - opt.completion);

		return opt;
	};

	fade = opt => {
		const { fade } = opt;
		opt.style.opacity = fade === "in" ? opt.completion : 1 - opt.completion;
		return opt;
	};

	scrollToFrame = (frame = 1) => {
		if (frame <= 0) frame = 1;
		let frameCount = 875;
		let height = 20000 - window.innerHeight;
		let r = frame / frameCount;
		window.scrollTo(0, r * height);
	};

	render() {
		const { showNavLogo, currentFrame, width, height } = this.state;

		const logoAnimate = [
			{
				frameIn: 345,
				frameOut: 358,
				scale: { from: 0.5, to: 1 },
				fade: "in"
			},
			{ frameIn: 359, frameOut: 369, scale: { from: 1, to: 0.5 }, fade: "out" }
		];

		return (
			<div>
				<MainMenu initClassName={showNavLogo ? "" : "init-bottom"} />
				<div
					style={{
						backgroundColor: "#000",
						display: "flex",
						flexDirection: "row",

						width: "100vw",
						position: "fixed",
						top: 56,
						zIndex: 1230
					}}
					className="homeNavContainer">
					<button
						className="homeNavBtn"
						onClick={() => this.scrollToFrame(202)}>
						pro suits
					</button>
					<button
						className="homeNavBtn"
						onClick={() => this.scrollToFrame(317)}>
						the difference
					</button>
					<button
						className="homeNavBtn"
						onClick={() => this.scrollToFrame(358)}>
						our teams
					</button>
					<button
						className="homeNavBtn"
						onClick={() => this.scrollToFrame(427)}>
						ski clubs
					</button>
					<button
						className="homeNavBtn"
						onClick={() => this.scrollToFrame(541)}>
						social
					</button>
					<button
						className="homeNavBtn"
						onClick={() => this.scrollToFrame(824)}>
						contact
					</button>
				</div>
				<VideoBackground updateCurrentFrame={this.updateCurrentFrame} />

				<div
					className={`container-fluid logo-container d-flex align-items-center`}>
					<VisibiltySensor
						onChange={isVisible => {
							this.setState({ showNavLogo: !isVisible });
						}}>
						<img
							src="images/logo/LogoGreenXGradient.svg"
							width="500"
							className="d-flex mx-auto align-self-center"
							rel="QwixSkinz"
						/>
					</VisibiltySensor>
				</div>
				<div className="homeContent position-fixed fixed-top">
					{/* Global Scroll Helper */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 0, frameOut: 189 },
								{ frameIn: 189, frameOut: 202, fade: "out" },
								{ frameIn: 203, frameOut: 227, fade: "in" },
								{ frameIn: 228, frameOut: 303 },
								{ frameIn: 304, frameOut: 317, fade: "out" },
								{ frameIn: 359, frameOut: 361, fade: "in" },
								{ frameIn: 362, frameOut: 413 },
								{ frameIn: 414, frameOut: 427, fade: "out" },

								{ frameIn: 428, frameOut: 431, fade: "in" },
								{ frameIn: 431, frameOut: 527 },
								{ frameIn: 528, frameOut: 541, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width,
								left: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>
					{/* End Global Scroll Helper */}

					<div
						className="animate"
						style={this.animate(
							[
								{ frameIn: 60, frameOut: 80, fade: "in" },
								{ frameIn: 60, frameOut: 98, scale: { from: 1, to: 0.5 } },
								{ frameIn: 90, frameOut: 98, fade: "out" }
							],
							{
								backgroundColor: "rgba(255,255,255,0.2)",
								height: "100vh",
								width: "100vw",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "center"
							}
						)}>
						<h2>We</h2>
						<h3>Make</h3>
						<h1>RACE SUITS</h1>
					</div>

					<div
						className="animate"
						style={this.animate(
							[
								{ frameIn: 123, frameOut: 147, fade: "in" },
								{ frameIn: 147, frameOut: 154, fade: "out" }
							],
							{
								height: "100vh",
								width: "100vw",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "center"
							}
						)}>
						<h1 className="text-center">FOR THE BEST</h1>
					</div>

					{/* Suits Section Frames (189 - 227) stopFrame 202 */}
					{/* Section Title */}
					<div
						className="animate"
						style={this.animate(
							[
								{
									frameIn: 189,
									frameOut: 202,
									move: {
										startPosition: {
											sx: 0 - width * 0.65,
											sy: height - 100
										},
										endPosition: {
											ex: 0,
											ey: height - 100
										}
									}
								},
								{
									frameIn: 203,
									frameOut: 227,
									move: {
										startPosition: {
											sx: 0,
											sy: height - 100
										},
										endPosition: {
											ex: 0,
											ey: height - 100
										}
									},
									fade: "out"
								}
							],
							{
								width: width * 0.65,
								textAlign: "center",
								color: "black"
							}
						)}>
						<h3>Check Out Our Suits</h3>
					</div>
					{/* Sport Block Section */}
					<div
						className="animate suitsContainer"
						style={this.animate(
							[
								{
									frameIn: 189,
									frameOut: 202,
									move: {
										startPosition: {
											sx: width + width * 0.35,
											sy: -100
										},
										endPosition: { ex: width * 0.65, sy: 0 }
									}
								},
								{
									frameIn: 203,
									frameOut: 227,
									fade: "out",
									move: {
										startPosition: { sx: width * 0.65, sy: 0 },
										endPosition: { ex: width * 0.65, ey: 0 }
									}
								}
							],
							{
								width: width * 0.35,
								padding: "70px 15px 0px 15px",
								top: 0,
								height: "100vh",
								backgroundColor: "black",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "around",
								overflowY: "auto"
							}
						)}>
						<Link to="/suits/alpine" className="sportBlock">
							<div className="sportIcon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="sport gradient"
									viewBox="0 0 172.91 172.89">
									<defs>
										<radialGradient
											id="radialGradient1"
											cy="50%"
											cx="50%"
											r="75%"

											// cy="60%"
											// fx="45%"
											// fy="45%"
											// r="2"
										>
											<stop offset="0%" stopColor="rgb(28, 37, 7)" />
											<stop offset="10%" stopColor="rgb(145, 255, 113)" />
											<stop offset="20%" stopColor="rgb(50, 221, 0)" />
											<stop offset="30%" stopColor="rgb(74, 202, 19)" />
											<stop offset="40%" stopColor="rgb(137, 184, 37)" />
											<stop offset="50%" stopColor="rgb(101, 136, 28)" />
											<stop offset="60%" stopColor="rgb(63, 85, 17)" />
											<stop offset="70%" stopColor="rgb(137, 184, 37)" />
											<stop offset="80%" stopColor="rgb(51, 51, 51)" />
											<stop offset="90%" stopColor="rgb(0, 0, 0)" />
											<stop offset="100%" stopColor="rgb(137, 184, 37)" />
											{/* <stop offset="0%" stopColor="#1C2507" />
                      <stop offset="10%" stopColor="#91FF71" />
                      <stop offset="20%" stopColor="#32DD00" />
                      <stop offset="30%" stopColor="#4ACA13" />
                      <stop offset="40%" stopColor="#89B825" />
                      <stop offset="50%" stopColor="#65881C" />
                      <stop offset="60%" stopColor="#3F5511" />
                      <stop offset="70%" stopColor="#89B825" />
                      <stop offset="80%" stopColor="#333333" />
                      <stop offset="90%" stopColor="#000000" />
                      <stop offset="100%" stopColor="#89B825" /> */}
										</radialGradient>
									</defs>
									<g>
										<path d="M130.06,96l19.35,6.56c-2.59-15.76-8.2-30.26-20.52-40-.33,4.69-3.27,7.44-7.58,9a54.69,54.69,0,0,1,16.94,22.78l-6.75-2.28A10.13,10.13,0,0,1,130.06,96ZM74,45.22h0c16.63-1.28,35.47.36,48.69,11.13a5.88,5.88,0,0,1,.85,8.28c-1.38,1.7-2.78,1.93-4.66,2.32-17.89,3.71-31.31,11.17-37,29a5.87,5.87,0,0,1-3.38,3.65l-.75.28A87.6,87.6,0,0,0,48.42,116L91.09,140l-8.08.24L10,99.29l4-2.58L40,111.27c9.19-9.39,16.9-16.55,31.69-21.81,5.77-15.24,16.52-24.62,31.08-30.13a100.88,100.88,0,0,0-26.87-4.14L46.55,12.46l5.78,1L74,45.22Zm65.71-.37h0a9.67,9.67,0,1,1-9.67,9.67,9.67,9.67,0,0,1,9.67-9.67Zm-40,33.74h0c8.29,1.2,19,3.9,25.21,7.37a5.88,5.88,0,0,1,2.28,8,6,6,0,0,1-3.46,2.8c-12.2,4.78-23.15,11.57-28.6,23.1l48.33,18L136.94,140,61.57,111.82l4.79-2.7,17.76,6.62c4.72-10.55,12.6-18.1,22.5-23.83a79.73,79.73,0,0,0-17.19-2.39c0-2.07,6.71-8.36,8.51-9.7q.87-.64,1.78-1.23ZM81.74.13a86.15,86.15,0,0,1,29.84,3.61h0l.32.1a86.42,86.42,0,0,1,57.25,107.72h0l-.1.32A86.42,86.42,0,0,1,61.33,169.14h0L61,169A86.43,86.43,0,0,1,3.76,61.31h0l.1-.32A86.09,86.09,0,0,1,20.06,31.1l3.23,2.69A82.55,82.55,0,0,0,7.88,62.19v0A82.23,82.23,0,0,0,62.23,165h0A82.23,82.23,0,0,0,165,110.67v0A82.23,82.23,0,0,0,110.68,7.86h0A82.56,82.56,0,0,0,82,4.33Z" />
									</g>
								</svg>
								{/* <object
                                    data="images/banners/icons/alpine_rnd.svg"
                                    width="75"
                                    height="75"
                                    className="gradientObj"
                                >
                                    <img
                                        src="images/banners/icons/alpine_rnd.svg"
                                        className="gradient"
                                    />
                                </object> */}
								Alpine
							</div>
							<div className="sportInfo">
								Qwixskinz makes world class apline race suits for both Downhill
								and Giant Slalom.
							</div>
						</Link>
						<Link to="/suits/bobsleigh" className="sportBlock">
							<div className="sportIcon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="sport gradient"
									viewBox="0 0 172.88 172.88">
									<g>
										<path d="M40.49,13.23A86.52,86.52,0,1,1,2.47,66l4.08,1A82.2,82.2,0,1,0,42.73,16.79Z" />
										<path d="M120.25,141.23l-2.81-6.73-21-13.16-4.82,1.95,28.6,17.94ZM20.56,75l2.81,6.73,49.74,31.21L77.94,111,20.56,75Zm1.5-8.83h0A193.41,193.41,0,0,0,44.34,78.48l.1,0,3.06,2.56q3.57,3,7.07,6.12Q48.76,85,42.8,82.28a184.76,184.76,0,0,1-16.56-8.75L24.35,72.4l-2.28-6.23ZM46,28.28a9.67,9.67,0,1,0,9.67,9.67A9.67,9.67,0,0,0,46,28.28Zm23.77,8.44a9.67,9.67,0,1,0,9.67,9.67,9.67,9.67,0,0,0-9.67-9.67ZM85.51,47.16l1.36,1.1c26.93,21.69,48.94,39.42,58.5,76a5.88,5.88,0,0,1-7.26,7.15,219.73,219.73,0,0,1-30.76-10,140.25,140.25,0,0,1-31.13-18,5.89,5.89,0,0,1-.87-.81h0C68.66,94.88,57,84.47,44.69,74.91,37.5,69.33,30.1,64,23.36,59.79L17.19,42.72c9.69,4.74,22.51,13.41,34.7,22.87,12.73,9.88,24.83,20.67,32,28.79a128.56,128.56,0,0,0,28,16.15,177.31,177.31,0,0,0,18.91,6.64c-9.14-24.37-26-39.2-46.26-55.65Z" />
									</g>
								</svg>
								{/* <object
                                    data="images/banners/icons/bobsleigh_rnd.svg"
                                    width="75"
                                    height="75"
                                    className="gradient"
                                >
                                    <img src="images/banners/icons/bobsleigh_rnd.svg" />
                                </object> */}
								Bobsleigh
							</div>
							<div className="sportInfo">
								Qwixskinz Bobsleigh Race Suits are worn by every level of
								Bobsleigh team from development to World Cup Champions.
							</div>
						</Link>
						<Link to="/suits/luge" className="sportBlock">
							<div className="sportIcon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="sport gradient"
									viewBox="0 0 172.88 172.88">
									<g>
										<path d="M45.75,81.14l-2.17,3.6,79.22,47.46a43.08,43.08,0,0,0,11.93,4.61,28.51,28.51,0,0,0,11.2.59l-.77-4.14a24.36,24.36,0,0,1-9.5-.55A38.63,38.63,0,0,1,125,128.6l-26.9-16.11,6-8.62c-3.45-2.39-8.74-6.89-14.27-11.67,18.55,11.46,36.71,23.43,54.16,36.52l15.82-2.95C132.43,105.26,91.48,77.57,59.2,61.34c-2.81-1.41-5.3-3.13-8.47-1.39a5.88,5.88,0,0,0-2.34,8C56.12,82,82,101.48,94.91,110.59L45.75,81.14Zm13.4,16.6,55.24,33.09,1.07,5.54L52.88,98.89l6.27-1.15ZM41.75,41.58h0a9.67,9.67,0,1,1-9,10.26,9.67,9.67,0,0,1,9-10.26Zm87.46,120a86.43,86.43,0,1,1,43.67-75.11q0,3.93-.38,8t-1.11,7.95l-4.13-.77q.71-3.78,1.06-7.55t.35-7.63a82.21,82.21,0,1,0-41.53,71.45Z" />
									</g>
								</svg>
								{/* <object
                                    data="images/banners/icons/luge_rnd.svg"
                                    width="75"
                                    height="75"
                                >
                                    <img src="images/banners/icons/luge_rnd.svg" />
                                </object> */}
								Luge
							</div>
							<div className="sportInfo">
								Our World Cup Luge Race Suit will give any Luge racer the
								advantage when every .001 of a second counts.
							</div>
						</Link>
						<Link to="/suits/skeleton" className="sportBlock">
							<div className="sportIcon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="sport gradient"
									viewBox="0 0 172.88 172.88">
									<g>
										<path d="M41.51,35,39.17,49.79c3.92,4.16,7.81,8.19,11.7,12,5.25,1.92,10.59,3.49,15,4.85s9,2.78,13.52,4.33a140.73,140.73,0,0,1-11.08-8.94C59.62,54.34,50.7,45,41.51,35ZM30,90.33l59,23.9c-3.37-6-5.06-12.41-1.92-17.69a5.87,5.87,0,0,1,4.74-2.87l-.9-.49c-8.79-4.77-19.38-8-29.7-11.24C49.89,78.44,38.89,75,30.11,69.82l1.56-13.21c7.73,6.27,20.14,10.11,33,14.08,11,3.39,22.19,6.86,31.85,12.11a126.84,126.84,0,0,1,18.17,11.72A52.7,52.7,0,0,1,127,107.77a5.9,5.9,0,0,1-4.42,9.28c-5.24.36-12.1-3.18-18.81-6.64-1.93-1-3.84-2-5.55-2.81,2.78,5,9.12,11.8,12.54,15.47h0L141,135.33l-9.1.83L26.45,93.44,30,90.33Zm110.32,9.81a9.67,9.67,0,1,0,8.86,10.42,9.67,9.67,0,0,0-8.86-10.42Zm27.31-.54q.52-3.21.79-6.56t.26-6.6A82.26,82.26,0,1,0,137.32,151l2.6,3.31a86.44,86.44,0,1,1,33-67.91q0,3.45-.28,6.93t-.84,6.89Z" />
									</g>
								</svg>
								{/* <object
                                    data="images/banners/icons/skeleton_rnd.svg"
                                    width="75"
                                    height="75"
                                >
                                    <img src="images/banners/icons/skeleton_rnd.svg" />
                                </object> */}
								Skeleton
							</div>
							<div className="sportInfo">
								Worn by World, World Cup & Olympic Champions our Skeleton Race
								Suit is the gold standard in World Cup Skeleton racing.
							</div>
						</Link>
						<Link to="/suits/speedskating" className="sportBlock">
							<div className="sportIcon">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="sport gradient"
									viewBox="0 0 172.88 172.88">
									<g>
										<path d="M138.27,57.85a9.67,9.67,0,1,0,9.67,9.67,9.67,9.67,0,0,0-9.67-9.67ZM26,104.94,21.56,106l14.28,16.34,4.72-.81L37,117.51c11.23-3.46,20.94-9.21,28.32-13.84,1.56-1,3.13-2,4.09-2.55A5.86,5.86,0,0,0,72,98.27c7.77-17.83,28.06-24.85,47.74-24.85v0A5.9,5.9,0,0,0,124,63.46C108.6,47.26,82,45.09,63.58,46.72l1,11.76c10.31-.91,25.75-.64,38.36,4.71a68.45,68.45,0,0,0-19.19,6.67A49.49,49.49,0,0,0,62,91.85L59,93.7c-7.79,4.89-18.14,11-30.66,13.94L26,104.94ZM96.89,81.43h0c6,1.85,11.74,4.38,15.31,7.06A5.87,5.87,0,0,1,114.55,93h0c.31,9.68-6.09,22.6-11.13,32.6l13.5.26L112.34,130,81,129.4l3.35-4.16,6.08.12c1-2.12,1.59-3.2,2.16-4.33,3.92-7.78,8.93-17.72,10-24.72A55.11,55.11,0,0,0,93,92.56a66.23,66.23,0,0,0-10.4-2.25A37.42,37.42,0,0,1,91.28,84a46.44,46.44,0,0,1,5.61-2.53Zm75.28,16a86.43,86.43,0,1,1-27.09-74.45L142.23,26A82.21,82.21,0,1,0,168,96.86Z" />
									</g>
								</svg>
								{/* <object
                                    data="images/banners/icons/speedskating_rnd.svg"
                                    width="75"
                                    height="75"
                                >
                                    <img src="images/banners/icons/speedskating_rnd.svg" />
                                </object> */}
								Speed Skating
							</div>
							<div className="sportInfo">
								Our national level race suit is the best in aerodynamic
								construction while providing durability & accommodating fit.
							</div>
						</Link>
					</div>
					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 200, frameOut: 202, fade: "in" },
								{ frameIn: 203, frameOut: 205, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width * 0.65,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>

					{/* End Suit Section */}

					{/* Every Second Counts (304 - 327) Stop Frame 317*/}
					<div
						className="animate"
						style={this.animate(
							[
								{
									frameIn: 304,
									frameOut: 317,
									move: {
										startPosition: {
											sx: 0 - width * 0.6,
											sy: 0
										},
										endPosition: {
											ex: 0,
											ey: 0
										}
									}
								}
							],
							{
								height: "100vh",
								width: width * 0.6,
								backgroundColor: "rgba(0,0,0,0.7)",
								padding: "90px 10px 10px 10px",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "center"
							}
						)}>
						<h2 className="title">Every Second Counts</h2>
						<div className="contentBlock">
							<p className="lead">
								Knowing that science &amp; design have come together to produce
								their best suit for their best day allows an athlete to unleash
								their performance and take it to the next level.
							</p>
							<p>
								There is something that happens when an athlete puts on a well
								fitting suit…like a superhero, they suddenly stand taller, feel
								a stronger, focus &amp; perform at a level that they once could only
								dream of.
							</p>
							<p className="mb-0">
								Our research team that includes collaborations with world
								renowned aerodynamic experts, innovators &amp; designers allows us
								to constantly expand our abilities to provide the best for the
								athlete.
							</p>
						</div>
					</div>
					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 315, frameOut: 317, fade: "in" },
								{ frameIn: 318, frameOut: 320, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width * 0.4,
								right: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>

					{/* End Every Second Counts Section */}

					{/* Team  Section Stop  (345-371)  Frame 358 */}
					<div
						className="animate"
						style={this.animate([{ frameIn: 345, frameOut: 371 }], {
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-around",
							padding: "70px 0px",
							height: "100vh",
							textAlign: "center"
						})}>
						<div>
							<h2 className="title" style={this.animate(logoAnimate)}>
								<span
									style={{
										display: "block",
										fontSize: "1rem",
										textTransform: "uppercase"
									}}>
									Some of
								</span>
								Our Teams
							</h2>
						</div>
						<div
							className="logoRow"
							style={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "space-around",
								alignItems: "center",
								flexWrap: "wrap"
							}}>


							<div
								className="animate logoBlock d-flex justify-content-center align-items-center"
								style={this.animate(logoAnimate, {
									width: "150px",
									height: "150px",
									padding: "5px",
									margin: "5px",
									backgroundColor: "rgba(0,0,0,0.4)"
								})}>
								<img src="/images/clubLogos/teamUsaLogo.png" />
							</div>

							<div
								className="animate logoBlock d-flex justify-content-center align-items-center"
								style={this.animate(logoAnimate, {
									width: "150px",
									height: "150px",
									padding: "5px",
									margin: "5px",
									backgroundColor: "rgba(0,0,0,0.4)"
								})}>
								<img src="/images/clubLogos/teamLV.png" />
							</div>

							<div
								className="animate logoBlock d-flex justify-content-center align-items-center"
								style={this.animate(logoAnimate, {
									width: "150px",
									height: "150px",
									padding: "5px",
									margin: "5px",
									backgroundColor: "rgba(0,0,0,0.4)"
								})}>
								{" "}
								<img src="/images/clubLogos/teamNZ.png" />{" "}
							</div>
						</div>
					</div>

					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 356, frameOut: 358, fade: "in" },
								{ frameIn: 359, frameOut: 361, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width,
								left: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>

					{/* End Team Section */}

					{/* Not Just For Pros (414 - ) stopFrame 427 */}

					{/* [Section Name] content*/}
					<div
						className="animate"
						style={this.animate(
							[
								{
									frameIn: 414,
									frameOut: 427,
									move: {
										startPosition: { sx: width + width * 0.6, sy: 0 },
										endPosition: { ex: width * 0.4, ey: 0 }
									}
								},
								{
									frameIn: 428,
									frameOut: 431,
									move: {
										startPosition: { sx: width * 0.4, sy: 0 },
										endPosition: { ex: width * 0.4, ey: 0 }
									},
									fade: "out"
								}
							],
							{
								width: width * 0.6,
								height: "100vh",
								paddingTop: "70px",
								backgroundColor: "rgba(0,0,0,0.4)",
								padding: "90px 25px 10px 10px",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "center"
							}
						)}>
						<h2 className="title">Not Just For The Pros</h2>
						<div className="contentBlock mb-2">
							<p className="lead">
								After years of producing race suits for World Cup, Olympic &amp;
								World champion athletes, Qwixskinz saw the need for a new, high
								quality option for the alpine ski clubs, youth/development &amp;
								university level racers.
							</p>
							<p>
								Working with our fabric developers we now provide a range of
								exclusive, high quality fabrics for this collection that allows
								fabrics options to be tailored to the racer’s needs.
							</p>
							<p>
								From the youngest skiers that need a durable suit that also
								protects them from the wind &amp; moisture while looking like a pro
								to the development &amp; university level racers that need FIS
								approved race suits while giving them the aerodynamic edge
								Qwixskinz is known for.
							</p>
							<p className="mb-0">
								Our 3D “Build your Suit” option, Coming soon on our website,
								will allow you to see what your club/team can look like from all
								angles &amp; start your custom design process. Our Fit Kits will
								allow your racers to try on the suits for sizing &amp; not be
								guessing from a size chart.
							</p>
						</div>
						<div className="d-flex flex-row flex-wrap w-100">
							<Link to="/clubsuits" className="plainBtn">
								Club Suits
							</Link>
							<Link
								to="/suitbuilder"
								className="plainBtn"
								style={{ display: "none" }}>
								Suit Builder
							</Link>
						</div>
					</div>

					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 425, frameOut: 427, fade: "in" },
								{ frameIn: 428, frameOut: 430, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width * 0.4,
								left: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "black"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>
					{/* End Not Just For Pros  */}

					{/* Sport Meets Science (frameIn - frameOut) stopFrame 541 */}

					{/* Sport Meets Science Content */}
					<div
						className="animate"
						style={this.animate(
							[
								{
									frameIn: 528,
									frameOut: 541,
									move: {
										startPosition: { sx: 0, sy: height * -0.7 },
										endPosition: { ex: 0, ey: 0 }
									}
								},
								{
									frameIn: 542,
									frameOut: 555,
									move: {
										startPosition: { sx: 0, sy: 0 },
										endPosition: { ex: 0, ey: height * -0.7 }
									},
									fade: "out"
								}
							],
							{
								height: height * 0.7,
								width: "100vw",
								backgroundColor: "rgba(0,0,0,0.4)",
								paddingTop: "25px"
							}
						)}>
						<InstagramFeed />
					</div>

					{/* Footer (862 - 875) Stop Frame (End) 875*/}
					<div
						className="animate"
						style={this.animate(
							[
								{
									frameIn: 862,
									frameOut: 875,
									move: {
										startPosition: { sx: 0, sy: height + height * 0.5 },
										endPosition: { ex: 0, ey: height * 0.5 }
									}
								}
							],
							{
								width: "100vw",
								height: height * 0.5,
								backgroundColor: "rgba(0,0,0,0.5)",
								display: "flex",
								flexDirection: "row"
							}
						)}
					/>

					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 539, frameOut: 541, fade: "in" },
								{ frameIn: 542, frameOut: 544, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width,
								left: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>
					{/* [End Section Name ] */}

					{/* Tagline (frameIn - frameOut) stopFrame 598 */}

					{/* inital move move: {
                        startPosition: { sx: width * -1, sy: height/2.25 },
                        endPosition: { ex: 0, ey: height/2.25 }
                    } */}

					<div
						className="animate"
						style={this.animate(
							[
								{ frameIn: 579, frameOut: 598, fade: "in" },
								{ frameIn: 599, frameOut: 613, fade: "out" }
							],
							{
								position: "absolute",
								top: 0,
								bottom: 0,
								left: 0,
								right: 0,
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}
						)}>
						<h3 className="text-center w-100">
							At Qwixskinz we are proud to be part of every athlete’s{" "}
							<b style={{ color: "var(--main-color)" }}>BEST</b> day.
						</h3>
					</div>

					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 596, frameOut: 598, fade: "in" },
								{ frameIn: 599, frameOut: 601, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width,
								left: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>
					{/* End Tagline */}

					{/* Contact Form (frameIn - frameOut) stopFrame 824 */}

					<div
						className="animate"
						style={this.animate(
							[
								{ frameIn: 800, frameOut: 824, fade: "in" },
								{ frameIn: 825, frameOut: 835, fade: "out" }
							],
							{
								position: "absolute",
								top: 0,
								bottom: 0,
								left: 0,
								right: 0,
								display: "flex",

								flexWrap: "wrap",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center"
							}
						)}>
						<div className="m-3 p-3">
							<h2 className="title">Get In Touch?</h2>
							<p>
								Need a new Suit? Have a Question? Great! We would love to hear
								from you! Please send us a quick message about what you're
								looking for and any questions you may have.
							</p>
						</div>
						<div className="homeContactForm m-3 p-3">
							<ContactForm />
						</div>
					</div>
					{/* scroll indicator */}
					<div
						className="animate scrollIndicator"
						style={this.animate(
							[
								{ frameIn: 822, frameOut: 824, fade: "in" },
								{ frameIn: 825, frameOut: 827, fade: "out" }
							],
							{
								position: "fixed",
								top: height - 50,
								width: width,
								left: 0,
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								color: "darkgrey"
							}
						)}>
						<object
							data="images/fa/regular/chevron-down.svg"
							type="image/svg+xml"
							className="fa scrollArrow"
							width="20"
							height="20"
						/>
						<p>Scroll Down For More</p>
					</div>
					{/* End Contact  */}

					{/* Footer stopFrame 875 */}

					<div
						className="animate"
						style={this.animate([{ frameIn: 868, frameOut: 875, fade: "in" }], {
							position: "absolute",
							top: "calc( 50% - 45px)",
							left: 0,
							right: 0,
							display: "flex",
							justifyContent: "center",
							alignItems: "center"
						})}>
						<h2 className="title text-center">Thanks For Visting!</h2>
					</div>

					<div
						className="animate"
						style={this.animate(
							[
								{
									frameIn: 868,
									frameOut: 875,
									move: {
										startPosition: { sx: 0, sy: height + height * 0.5 },
										endPosition: { ex: 0, ey: height * 0.5 }
									}
								}
							],
							{
								height: "50vh",
								width: "100vw",
								display: "flex",
								justifyContent: "center",
								alignItems: "center"
							}
						)}>
						<Footer />
					</div>
					{/* End Footer  */}

					{/* Temp frame position */}
					<div
						style={{
							visibility: "hidden",
							position: "fixed",
							opacity: 0.3,
							bottom: 10,
							right: 10,
							width: 40,
							height: 40,
							borderRadius: 10,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							lineHeight: 40,
							zIndex: 200,
							backgroundColor: "black",
							color: "white"
						}}>
						{currentFrame}
					</div>
				</div>
			</div>
		);
	}
}
